import React, { useEffect, useState } from "react"
import { Modal, Table, InputNumber, Button, message } from "antd"
import axios from "axios"
import SettingPriceService from "src/services/SettingPriceService"

const SimVariantModal = ({ visible, onClose, record }) => {
  const [variants, setVariants] = useState([])
  const [loading, setLoading] = useState(false)
  const [priceUpdates, setPriceUpdates] = useState({})

  // Giả lập fetch dữ liệu từ API
  useEffect(() => {
    console.log(record, "record")
    fetchDetailPrice()
  }, [visible])

  const fetchDetailPrice = async () => {
    setLoading(true)
    try {
      const response = await SettingPriceService.getDetailPrice({
        country_id: record?.country_id,
        carrier_id: record?.carrier_id,
      }) // Gọi API với ID
      setVariants(response.success || [])
      // if (response) {

      //   const initialValues = { ...input }
      //   response.data.forEach(record => {
      //     initialValues[`serial_number_${record.ID}`] = record.serial_number
      //     initialValues[`phone_number_${record.ID}`] = record.phone_number
      //   })
      // form.setFieldsValue(initialValues)
      // } else {
      //   message.error("Không tìm thấy thông tin sim.")
      // }
    } catch (error) {
      console.error("Lỗi khi lấy thông tin sim:", error)
      message.error(
        error.response?.data?.message || "Lỗi khi lấy thông tin sim.",
      )
    } finally {
      setLoading(false)
    }
  } // <-- API cần thay thế bằng endpoint thậtư
  // Cập nhật giá tạm thời trước khi gửi về API
  const handlePriceChange = (id, value) => {
    setPriceUpdates(prev => ({ ...prev, [id]: value }))
  }

  // Gửi cập nhật giá về API
  const handleSave = () => {
    // const updates = Object.entries(priceUpdates).map(([id, price]) => ({
    //   id,
    //   price,
    // }))
    // axios
    //   .post("/api/sim-variants/update-prices", updates)
    //   .then(() => {
    //     message.success("Cập nhật giá thành công!")
    //     onClose()
    //   })
    //   .catch(() => {
    //     message.error("Cập nhật thất bại.")
    //   })
  }

  const columns = [
    { title: "Quốc gia", dataIndex: "country_title", key: "country_title" },
    { title: "Nhà mạng", dataIndex: "carrier_name", key: "carrier_name" },
    {
      title: "Loại SIM",
      dataIndex: "type_sim",
      key: "type_sim",
      render: value => {
        if (value === "esim") return "E-SIM"
        if (value === "usim") return "Sim vật lý"
        return value
      },
    },
    {
      title: "Loại hình SIM",
      dataIndex: "sim_type",
      key: "sim_type",
      render: value => {
        if (value === "1") return "IoT"
        if (value === "2") return "Travel"
        return value
      },
    },
    {
      title: "Giá bán",
      dataIndex: "price",
      key: "price",
      render: (text, record) => (
        <InputNumber
          min={0}
          defaultValue={record.price}
          onChange={value => handlePriceChange(record.id, value)}
        />
      ),
    },
  ]

  return (
    <Modal
      title="Chi tiết giá bán SIM"
      visible={visible}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Hủy
        </Button>,
        <Button key="save" type="primary" onClick={handleSave}>
          Lưu
        </Button>,
      ]}
      width={900}
    >
      <Table
        dataSource={variants}
        columns={columns}
        rowKey="id"
        loading={loading}
        pagination={false}
      />
    </Modal>
  )
}

export default SimVariantModal
